import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button } from 'antd';
import { Translate } from 'react-jhipster';
import { getEleve, getPhoto, updatePaiementEleve } from './eleve.reducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const EleveDeleteModal = (props: RouteComponentProps<{ id: string; ecoleid: string; anneeScolaireId: string }>) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useAppDispatch();
  const eleve = useAppSelector(state => state.eleve.entity);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const id_ = props.match.params.id;
  const showModal = () => {
    setIsModalVisible(true);
  };
  useEffect(() => {
    dispatch(getEleve(props.match.params.id));
    dispatch(getPhoto(props.match.params.id));
  }, []);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/eleve/${currentEcole && currentEcole.id}/${props.match.params.anneeScolaireId}/${id_}/details`);
  };

  const confirmUpdate = event => {
    const entity = {
      ecoleId: props.match.params.ecoleid,
      id: props.match.params.id,
      etatPaiement: eleve.etatPaiement === 'A_JOUR' ? 'NON_A_JOUR' : 'A_JOUR',
    };
    dispatch(updatePaiementEleve(entity));
    handleClose(event);
  };

  const goBack = () => {
    props.history.goBack();
  };

  return (
    <>
      {eleve.id !== null && (
        <Modal
          title="Confirmation de changement du statut de paiement"
          centered
          footer={[
            <Button key="back" onClick={goBack}>
              Annuler
            </Button>,
            <Button key="submit" style={{ backgroundColor: '#cd201f', color: 'white' }} onClick={confirmUpdate}>
              Modifier
            </Button>,
          ]}
          visible={true}
          closable={false}
        >
          Etes-vous certain de vouloir changer l&apos;état de paiement de l&apos;élève {eleve.firstName} {eleve.lastName} ?
        </Modal>
      )}
    </>
  );
};

export default EleveDeleteModal;
